import React from "react"
import { observer } from "mobx-react-lite"
import useNavigation from "~hooks/useNavigation"
import useCheckBinding from "~hooks/useCheckBinding"
import { TextAccordion } from "~components/accordion"
import styled from '~/ui/styled'
import { useStores } from "~models"
import { prompt } from "~utils/prompt"
import { Event, EventNames, FLAG_ACK } from "~proto"
import { globalToast } from "~utils"

const Container = styled.View`
  margin: ${({ theme }) => `${theme.space.sm} 0px`};
`

const MyAccount: React.FC = () => {
  const navigation = useNavigation()
  const { handleCheckBindingPhone } = useCheckBinding()
  const { eventStore, configStore } = useStores()

  const handleDelete = () => {
    const evt = new Event(EventNames.USER_INACTIVE, {})
    eventStore.publish(evt, { flags: FLAG_ACK })
    navigation.navigate("ContactList")
    globalToast.show("已发送")
  }

  const handlePromptDelete = () => {
    prompt({
      title: "删除账号",
      message: `删除${configStore.appName}账号后, 您将无法再使用该账号登入。确定要继续吗?`,
      onSuccess: handleDelete,
    })
  }
  const handleChangePassword = () => {
    handleCheckBindingPhone().then(() => {
      navigation.push("ChangePassword")
    })
  }
  const handleChangePhone = () => {
    navigation.push("PhoneBinding")
  }

  return (
    <>
      <Container>
        <TextAccordion
          accordionProps={{
            onClick: handleChangePhone,
            label: "绑定手机",
            hasRightIcon: true,
          }}
          textProps={{}}
        />
        <TextAccordion
          accordionProps={{
            onClick: handleChangePassword,
            label: "修改登录密码",
            hasRightIcon: true,
          }}
          textProps={{}}
        />
        <TextAccordion
          accordionProps={{
            onClick: handlePromptDelete,
            label: "删除账号",
            hasRightIcon: true,
          }}
          textProps={{}}
        />
      </Container>
    </>
  )
}

export default observer(MyAccount)
